import React from 'react'
import styles from './FeatureModal.module.css'
import { FEATURES } from './features'

const FeatureCard = ({ featureType = 'feedback', mainTitle }) => {
  const feature = FEATURES[featureType] || FEATURES.feedback

  return (
    <div className={styles.featureModal}>
      <div className={styles.mainTitle}>{mainTitle}</div>
      <div className={styles.featureCard}>
        <div className={styles.featureContent}>
          <div className={styles.featureIllustration}>
            <img src={feature.illustration} alt={feature.title} width="120" height="80" />
          </div>
          <div className={styles.featureText}>
            <div className={styles.featureName}>
              <img src={feature.icon} alt={feature.title} className={styles.featureIcon} />
              {feature.title}
            </div>
            <p className={styles.featureDescription}>{feature.description}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FeatureCard
